import { Component, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-empty-basket',
  templateUrl: './empty-basket.component.html',
  styleUrls: ['./empty-basket.component.scss'],
})
export class EmptyBasketComponent {
  @Input()
  label = '';
}
